import request from './request'

function playRemoteAudio(fileName) {
  return request({
    url: '/proxy/outputs/' + fileName,
    method: 'get',
    responseType: 'blob'
  })
}

function uploadAudio(data) {//音频文件
  return request({
    url: '/proxy/upload',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

function uploadVideo(data) {//视频文件
  return request({
    // url: '/proxy/upload',
    url: '/proxy/analyze_interview',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 处理音频流并获取响应，使用请求类和代理以解决跨域问题
function processAudioStream(audioBlob, interview_id) {
  console.log('准备提交音频数据，interview_id:', interview_id);
  console.log('音频数据大小:', audioBlob.size, 'bytes');
  console.log('音频数据类型:', audioBlob.type);

  if (!audioBlob || audioBlob.size === 0) {
    return Promise.reject(new Error('音频数据为空或无效'));
  }

  if (!interview_id) {
    return Promise.reject(new Error('面试ID不能为空'));
  }

  const formData = new FormData();
  formData.append('audio_file', audioBlob, 'recording.wav');
  formData.append('interview_id', interview_id);

  // 添加调试日志查看formData内容
  for (const pair of formData.entries()) {
    if (pair[0] === 'audio_file') {
      console.log('FormData - audio_file:', pair[1], '类型:', pair[1].type, '大小:', pair[1].size);
    } else {
      console.log('FormData - ' + pair[0] + ':', pair[1]);
    }
  }

  // 不同的响应类型
  const responseTypes = [
    { type: 'text', label: '文本' },
    { type: 'json', label: 'JSON' }
  ];

  // 使用第一种响应类型 (text)
  const selectedType = responseTypes[0];

  console.log(`尝试使用 ${selectedType.label} 响应类型请求...`);

  // 设置更长的超时时间，考虑语音处理可能需要更长时间
  const MAX_RETRIES = 2;
  const RETRY_DELAY = 2000; // 2秒延迟

  // 添加重试机制
  return retryRequest(MAX_RETRIES);

  function retryRequest(retriesLeft) {
    console.log(`发送请求 (剩余重试次数: ${retriesLeft})...`);
    debugger
    return request({
      url: '/proxy/process_audio_stream', // 使用代理路径
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      responseType: selectedType.type,
      timeout: 180000 // 增加超时时间到3分钟
    }).catch(error => {
      console.error('请求失败:', error);

      // 如果是网络错误或超时，尝试重试
      if (
        retriesLeft > 0 &&
        (error.message.includes('Network Error') ||
          error.message.includes('timeout') ||
          (error.response && error.response.status >= 500))
      ) {
        console.log(`将在 ${RETRY_DELAY / 1000} 秒后重试请求...`);
        return new Promise(resolve => {
          setTimeout(() => {
            resolve(retryRequest(retriesLeft - 1));
          }, RETRY_DELAY);
        });
      }

      // 如果重试次数用完或不是网络错误，抛出错误
      throw error;
    });
  }
}

// 流式处理音频数据 - 支持实时流式输出
function processAudioStreamReal(audioBlob, interview_id, onData, onError, onComplete) {
  console.log('准备流式提交音频数据，interview_id:', interview_id);
  console.log('音频数据大小:', audioBlob.size, 'bytes');
  console.log('音频数据类型:', audioBlob.type);

  if (!audioBlob || audioBlob.size === 0) {
    if (onError) onError(new Error('音频数据为空或无效'));
    return;
  }

  if (!interview_id) {
    if (onError) onError(new Error('面试ID不能为空'));
    return;
  }

  const formData = new FormData();
  formData.append('audio_file', audioBlob, 'recording.wav');
  formData.append('interview_id', interview_id);

  // 获取baseURL
  let baseURL = '';
  if (process && process.env && process.env.VUE_APP_BASE_API) {
    baseURL = process.env.VUE_APP_BASE_API;
  }

  // 创建原生XHR请求以支持流式响应
  const xhr = new XMLHttpRequest();

  // 添加超时处理
  xhr.timeout = 180000; // 3分钟超时

  // 记录接收到的数据
  let receivedData = '';
  let lastProcessedIndex = 0;

  // 打开连接，使用代理路径
  xhr.open('POST', `${baseURL}/proxy/process_audio_stream`, true);

  // 设置监听器
  xhr.onprogress = function (e) {
    if (e.lengthComputable) {
      console.log(`已接收: ${e.loaded} / ${e.total} bytes`);
    } else {
      console.log(`已接收: ${e.loaded} bytes`);
    }

    // 获取新数据
    const newData = xhr.responseText.substring(lastProcessedIndex);
    if (newData.length > 0) {
      // 更新处理位置
      lastProcessedIndex = xhr.responseText.length;

      // 添加到总接收数据
      receivedData += newData;

      // 回调处理数据
      if (onData) onData(newData);
    }
  };

  xhr.onload = function () {
    if (xhr.status >= 200 && xhr.status < 300) {
      console.log('请求成功完成，状态码:', xhr.status);

      // 检查是否有未处理的数据
      if (xhr.responseText.length > lastProcessedIndex) {
        const finalData = xhr.responseText.substring(lastProcessedIndex);
        if (finalData.length > 0 && onData) {
          onData(finalData);
        }
      }

      // 完成回调
      if (onComplete) onComplete({
        status: xhr.status,
        statusText: xhr.statusText,
        headers: xhr.getAllResponseHeaders(),
        data: receivedData
      });
    } else {
      console.error('请求失败，状态码:', xhr.status);
      if (onError) onError(new Error(`请求失败: ${xhr.statusText}`));
    }
  };

  xhr.onerror = function (e) {
    console.error('请求错误:', e);
    if (onError) onError(new Error('网络错误'));
  };

  xhr.ontimeout = function () {
    console.error('请求超时');
    if (onError) onError(new Error('请求超时'));
  };

  // 发送请求
  try {
    xhr.send(formData);
    return xhr; // 返回xhr对象，允许调用者中止请求
  } catch (error) {
    console.error('发送请求失败:', error);
    if (onError) onError(error);
    return null;
  }
}

function analyzeInterview(data) {
  return request({
    url: '/api/newAIGC/analyze_interview',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}


//生成面试推荐指数
function generateFeedback(data) {
  return request({
    url: '/api/interview/generateFeedback',
    method: 'post',
    data
  })
}

function uploadInterviewVideo(formData) {
  return request({
    url: '/api/upload/videoCompress',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}
//将js文件导入到<script lang="ts">中时，请提供默认导出，具体原因不明
export default {
  uploadAudio,
  uploadVideo,
  playRemoteAudio,
  processAudioStream,
  processAudioStreamReal,
  analyzeInterview,
  generateFeedback,
  uploadInterviewVideo
}